// material-ui
import MuiGlobalStyles from '@mui/material/GlobalStyles';

// project-imports
import useConfig from 'hooks/useConfig';
import { htmlFontSize } from './typography';

// ==============================|| THEME - GLOBAL STYLE  ||============================== //

export default function GlobalStyles() {
  const {
    state: { fontSize }
  } = useConfig();

  return (
    <MuiGlobalStyles
      styles={(theme) => ({
        // the font-size setting scales the root so every rem-based size follows it
        html: {
          fontSize: htmlFontSize(fontSize)
        },
        // global-style -> apexcharts
        '.apexcharts-theme-dark .apexcharts-menu': {
          borderColor: theme.vars.palette.text.secondary,
          color: theme.vars.palette.text.primary,
          '& .apexcharts-menu-item:hover': {
            color: theme.vars.palette.primary.main
          }
        }
      })}
    />
  );
}
